import { useMemo } from 'react'
import type { ShopI18nContextValue } from '../../../i18n/provider/types'
import type { CustomerAuthField, CustomerAuthFieldErrorMap } from '../../hooks/useCustomerAuthForm'
import { buildCountryOptions } from './countryOptions'
import {
  buildCustomerAuthLabels,
  buildGenderOptions,
  PHONE_PREFIX_OPTIONS,
} from './useCustomerAuthFormBlockModel.data'

type UseCustomerAuthFormBlockModelParams = {
  locale: string
  t: ShopI18nContextValue['t']
  fieldErrorKeys: CustomerAuthFieldErrorMap
}

export const useCustomerAuthFormBlockModel = ({ locale, t, fieldErrorKeys }: UseCustomerAuthFormBlockModelParams) => {
  const fieldErrors = useMemo<Partial<Record<CustomerAuthField, string>>>(() => {
    const entries = Object.entries(fieldErrorKeys) as Array<[CustomerAuthField, (typeof fieldErrorKeys)[CustomerAuthField]]>
    return entries.reduce<Partial<Record<CustomerAuthField, string>>>((acc, [field, messageKey]) => {
      acc[field] = messageKey ? t(messageKey) : ''
      return acc
    }, {})
  }, [fieldErrorKeys, t])

  const genderOptions = useMemo(
    () => buildGenderOptions(t),
    [t],
  )

  const phonePrefixOptions = PHONE_PREFIX_OPTIONS
  const countryOptions = useMemo(() => buildCountryOptions(locale), [locale])

  const labels = useMemo(() => buildCustomerAuthLabels(t), [t])

  return { fieldErrors, genderOptions, phonePrefixOptions, countryOptions, labels }
}
